import { HandleErrorsService } from './handle-errors.service';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Language } from '../../schemas/language';
import { TranslocoService } from '@jsverse/transloco';
import { directusAuthInstance } from '../../libs/directus';
import { readItems } from '@directus/sdk';
import { RequestsService } from './requests.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  public languages = signal<Language[]>([]);
  public appLanguage = signal<Language | null>(this.getAppLanguage());
  private transloco = inject(TranslocoService);
  private handleErrorsService = inject(HandleErrorsService);
  private requestsService = inject(RequestsService);
  private directusClient = directusAuthInstance;

  constructor(private http: HttpClient) {}

  async init() {
    // const translocoLanguage = localStorage.getItem('translocoLang');
    // if (translocoLanguage && this.getLanguageByCode(translocoLanguage)) {
    //   const jsonLanguage = JSON.stringify(
    //     this.getLanguageByCode(translocoLanguage),
    //   );
    //   localStorage.setItem('language', jsonLanguage);
    // }
    await this.getAllLanguages();
    this.setAutoLanguage();
  }

  setAppLanguage(language: Language, type = 'user') {
    const jsonLanguage = JSON.stringify(language);
    if (jsonLanguage) {
      if (type !== 'user') {
        localStorage.setItem('autoLanguage', jsonLanguage);
      } else {
        localStorage.setItem('language', jsonLanguage);
      }
      this.transloco.setActiveLang(language.code!);
      // console.log('language', this.transloco.getActiveLang());
    } else {
      this.init();
    }
    // console.log('language', language);
  }

  setAutoLanguage() {
    if (this.appLanguage()) {
      return;
    }
    const browserLanguage = navigator.language.split('-')[0];
    const availableLanguages = this.languages().map(
      (language) => language.code,
    );

    if (availableLanguages.includes(browserLanguage)) {
      const language = this.languages().find(
        (lang) => lang.code === browserLanguage,
      )!;
      this.setAppLanguage(language, 'auto');
    } else {
      const defaultLanguage = this.languages().find(
        (lang) => lang.code === 'en',
      )!;
      this.setAppLanguage(defaultLanguage, 'auto');
    }
  }

  getAppLanguage(): Language | null {
    const language =
      localStorage.getItem('language') || localStorage.getItem('autoLanguage');
    return language ? JSON.parse(language) : null;
  }

  async getAllLanguages(): Promise<Language[]> {
    if (this.languages.length) {
      return this.languages();
    }

    try {
      const languages = await this.requestsService.handleRequest(() =>
        this.directusClient.request(
          readItems('languages', {
            filter: {
              is_active: {
                _eq: true,
              },
            },
            sort: 'sort',
            limit: -1,
          }),
        ),
      );

      this.languages.set(languages);
      return languages as Language[];
    } catch (error) {
      this.handleErrorsService.handleErrors(error);

      return [];
    }
  }

  getLanguageByCode(code: string): Language | null {
    const language = this.languages().find(
      (language) => language.code === code,
    );

    if (language) {
      return language;
    }
    return null;
  }

  getFilteredLanguages(): Language[] {
    // console.log(this.languages());
    return this.languages().filter((language) => language.is_active);
  }
}
